export const generateFrameworkPreviewDatasets = (frameworkLayersSources, framework, categories) => {
  console.log('Generating preview datasets for framework:', framework.title, frameworkLayersSources)
  const previewDatasets = frameworkLayersSources.map(layer => ({
    label: layer.label,
    opacity: layer.opacity,
    values: categories.map(() => Math.round(Math.random() * framework.maxValue)),
  }))

  // If we only have one layer but using stacked mode, add a transparent layer
  if (frameworkLayersSources.length === 1 && framework.viewMode === 'stacked') {
    previewDatasets.push({
      label: 'Background',
      opacity: 0.3,
      values: categories.map(() => Math.random() * framework.maxValue * 0.5),
    })
  }
  console.log('Generated preview datasets:', previewDatasets)
  return previewDatasets
}
